import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../common/html/checkbox'
import { checkItem, selectCheckeditem, uncheckItem } from './store/slice'

const CheckboxItem = ({ rowId }) => {
  const dispatch = useDispatch()

  const value = useSelector(selectCheckeditem(rowId))

  const onChange = (valChecked) => {
    if (valChecked) {
      dispatch(checkItem(rowId))
    } else {
      dispatch(uncheckItem(rowId))
    }
  }

  return <Checkbox checked={value} onChange={onChange} />
}

CheckboxItem.propTypes = {
  rowId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default CheckboxItem
